//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import remarkDialog from "./OrderPop/Remark.vue";
export default {
  data() {
    return {
      filterForm: {
        orderNum: "",
        goodsName: "",
        orderStatus: "30",
        user: "",
        supplierName: "",
        brandName: "",
        buyer: "",
        orderSource: "",
        mode: "",
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10,
      },
      expands: [],
      orderList: [
        {
          name: "村集体",
          id: "1",
        },
        {
          name: "合作社",
          id: "2",
        },
      ],
      sourceList: [
        {
          name: "自主下单",
          id: "0",
        },
        {
          name: "运营后台下单",
          id: "1",
        },
      ],
      pagination: {
        page: 1,
        size: 10,
        total: 0,
        loading: false,
      },
      remarkStatus: false,
      orderTabList: [],
      orderId: "",
      dateArr: [],
      showDialogPayment: false,
      confirmOrderId: "",
    };
  },
  components: {
    remarkDialog,
  },
  filters: {
    filterStatus(val) {
      if (val == 10) {
        return "待议价";
      } else if (val == 20) {
        return "待付款";
      } else if (val == 30) {
        return "待确认付款";
      } else if (val == 40) {
        return "待发货";
      } else if (val == 50) {
        return "已发货";
      } else if (val == 60) {
        return "已完成";
      } else if (val == 0) {
        return "已取消";
      }
    },
    filterPayStatus(val) {
      if (val == 0) {
        return "自主下单";
      } else if (val == 1) {
        return "运营后台下单";
      }
    },
  },
  mounted() {
    this.getOrderList();
  },
  methods: {
    handleFilter() {
      this.getOrderList();
    },
    getOrderList() {
      if (this.dateArr != null) {
        if (this.dateArr[0] != undefined) {
          this.filterForm.startTime = this.dateArr[0] + " " + "00:00:00";
        } else {
          this.filterForm.startTime = "";
        }

        if (this.dateArr[1] != undefined) {
          this.filterForm.endTime = this.dateArr[1] + " " + "23:59:59";
        } else {
          this.filterForm.endTime = "";
        }
      }
      this.$http.szOrder.getOrderPage(this.filterForm).then((res) => {
        if (res.status == 1) {
          this.orderTabList = res.data;
          this.pagination.total = res.count;
        }
      });
    },
    pickerChangeFn() {
      if (this.dateArr == null) {
        this.filterForm.startTime = "";
        this.filterForm.endTime = "";
      }
    },
    handleChange(val) {
      this.filterForm.orderSource = val;
    },
    handleChangePay(val) {
      this.filterForm.mode = val;
    },
    handleClick() {},
    handleReset() {
      this.filterForm.orderNum = "";
      this.filterForm.goodsName = "";
      this.filterForm.user = "";
      this.filterForm.supplierName = "";
      this.filterForm.brandName = "";
      this.filterForm.buyer = "";
      this.filterForm.orderSource = "";
      this.filterForm.mode = "";
      this.filterForm.endTime = "";
      this.filterForm.startTime = "";
      this.dateArr = [];
      this.$nextTick(() => {
        this.getOrderList();
      });
    },
    // 付款核实
    goSurePay(id) {
      this.showDialogPayment = true;
      this.confirmOrderId = id;
    },
    confirmPayment() {
      this.$http.szOrder
        .confirmPayment({
          orderId: this.confirmOrderId,
        })
        .then((res) => {
          if (res.status == 1) {
            this.$message({
              message: "付款核实成功",
              type: "success",
              duration: 3000,
            });
            this.showDialogPayment = false;
            this.getOrderList();
          }
        });
    },
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.filterForm.pageNum = val;
      this.getOrderList();
    },
    goSurePrice() {},
    checkLogistics() {},
    handleRemark(id) {
      this.remarkStatus = true;
      this.orderId = id;
    },
    getCloseStatus(val) {
      if (val == true) {
        this.remarkStatus = false;
        this.getOrderList();
      }
    },
    getCancelStatus(val) {
      if (val == true) {
        // 调列表接口
      }
    },
    goDetail(id, status) {
      let path = "/szoperation/order/details";
      this.$router.push({
        path,
        query: {
          id: id,
          orderStatus: status,
          flag: 3,
        },
      });
    },
  },
};
